export { AuthStep } from './AuthStep';
export { CompleteRegistrationStep } from './CompleteRegistrationStep';

// TODO: Export additional registration components as they're created
// export { DetailsStep } from './DetailsStep';
// export { RegistrationStepper } from './RegistrationStepper';
